export class ApiResponse<T> {

    constructor() {
    }
    type?: string;
    code?: number;
    msg: string;
    data: T;
}
